export const ADD_TO_CART = '@cart/created';
export const DELETE_FROM_CART = '@cart/deleted';
